import clsx from "clsx";
import React, { useState } from "react";
import LoadingSpinnerInline from "../../components/common/loading-spinner/loading-spinner-inline";

interface ModalProps {
  title: string;
  message: string;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

const Modal: React.FC<ModalProps> = ({
  title,
  message,
  onConfirm,
  onCancel,
}) => {
  const [buttonBlockStyle, setButtonBlockStyle] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-lg font-semibold mb-4">{title}</h2>
        <p className="text-gray-600 mb-6">{message}</p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
            disabled={isLoading}
          >
            취소
          </button>
          <button
            onClick={async () => {
              setButtonBlockStyle("pointer-events-none opacity-80");
              setIsLoading(true);
              await onConfirm();
              setIsLoading(false);
            }}
            className={clsx(
              "inline-flex items-center justify-center px-4 py-2 min-w-24",
              "bg-[#1562fc] text-white rounded-md active:bg-[#124ab7] transition duration-150",
              buttonBlockStyle
            )}
            disabled={isLoading}
          >
            {isLoading ? <LoadingSpinnerInline /> : "게시하기"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
